import React from 'react';
import RequestsCardItem from '../containers/RequestsCardItem';

const RequestsCardItems = ({
  category,
  items,
  onCheckBoxClick,
  review,
  single,
}) => (
  items.map((item, index) => (
    <RequestsCardItem
      category={category}
      key={`requests_list_item_${item.code}`}
      onCheckBoxClick={onCheckBoxClick}
      request={item}
      review={review}
      single={single}
      upward={index > 4}
    />
  ))
);

export default RequestsCardItems;
